var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIconPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6618 8.23629L16.6636 8.23442C16.6635 8.23458 16.6661 8.23183 16.6709 8.22537C16.6757 8.21906 16.6816 8.21048 16.6884 8.19959C16.7021 8.17744 16.7164 8.15012 16.7291 8.12016C16.7418 8.09014 16.7511 8.06171 16.7569 8.03768C16.7597 8.02591 16.7614 8.01646 16.7623 8.00946C16.7629 8.00538 16.7631 8.0026 16.7632 8.00109C16.7617 7.93343 16.7548 7.89984 16.7468 7.87732C16.7401 7.85874 16.7254 7.82672 16.6759 7.7781L16.6687 7.77109L16.6619 7.7638L9.92503 0.605839L9.92439 0.605164C9.79684 0.469137 9.57033 0.467489 9.44897 0.586804L9.44879 0.586983C9.32017 0.71331 9.32096 0.963388 9.42877 1.07737L9.42937 1.078L14.8372 6.81504L15.6317 7.658L14.4733 7.658L0.842048 7.658C0.653144 7.658 0.5 7.81107 0.5 8.00004C0.5 8.18895 0.653074 8.34209 0.842048 8.34209L14.4733 8.34209L15.6317 8.34209L14.8372 9.18505L9.42937 14.9221L9.42878 14.9227C9.3805 14.9737 9.34273 15.0638 9.34526 15.1725C9.34778 15.2808 9.38872 15.3587 9.43302 15.3986C9.59403 15.5433 9.79599 15.526 9.92786 15.3915L16.6618 8.23629Z",
    fill: "#DB7F2B",
    stroke: "#D30C7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIconPink);
export default __webpack_public_path__ + "static/media/link-icon-pink.f2ed75ff91ce74eeb2a864f70bf63127.svg";
export { ForwardRef as ReactComponent };